export enum BACEvents {
    Started = "BAC_Started",
    VendorInControl = "BAC_VendorInControl",
}